import { useEffect, useRef, useState } from 'react'

import { ViewerPosition } from '../types'

const RVT_STABILITY_PROJECT_ID = '33mhdxk2NDtQ'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper autodeskModule type
export const useViewer3D = (autodeskModule: any, projectId?: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper viewer type
  const [viewer, setViewer] = useState<any>(null)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper panoramaTool type
  const panoramaTool = useRef<any>(null)

  const getPitch = () => {
    if (panoramaTool.current) {
      return panoramaTool.current.getPitch()
    }
    return 0
  }

  const getYaw = () => {
    if (panoramaTool.current) {
      return panoramaTool.current.getYaw()
    }
    return 0
  }

  const getFov = () => {
    if (panoramaTool.current) {
      return panoramaTool.current.getFov()
    }
    return 0
  }

  const setPitch = (pitch: number) => {
    if (panoramaTool.current) {
      panoramaTool.current.setPitch(pitch)
    }
  }

  const setYaw = (yaw: number) => {
    if (panoramaTool.current) {
      panoramaTool.current.setYaw(yaw)
    }
  }

  const setFov = (fov: number) => {
    if (panoramaTool.current) {
      panoramaTool.current.setFov(fov)
    }
  }

  const getViewerPosition = () => {
    const viewerPosition: ViewerPosition = {
      pitch: getPitch(),
      yaw: getYaw(),
      hfov: getFov(),
    }
    return viewerPosition
  }

  const setViewerPosition = (viewerPosition: ViewerPosition) => {
    setPitch(viewerPosition.pitch)
    setYaw(viewerPosition.yaw)
    setFov(viewerPosition.hfov)
  }

  useEffect(() => {
    if (autodeskModule) {
      const Autodesk = autodeskModule
      const htmlDiv = document.getElementById('forgeViewer')
      const useMemoryLimitedLoader = projectId !== RVT_STABILITY_PROJECT_ID
      const options = {
        profileSettings: {
          bimWalkToolPopup: false,
          firstPersonToolPopup: false,
        },
        ...(useMemoryLimitedLoader
          ? {
              loaderExtensions: { svf: 'Autodesk.MemoryLimited' },
              extensions: [
                'Autodesk.Viewing.MemoryLimitedDebug',
                'Autodesk.BimWalk',
                'Autodesk.ViewerSettings',
                'PanoramaExtension',
              ],
            }
          : {
              extensions: [
                'Autodesk.BimWalk',
                'Autodesk.ViewerSettings',
                'PanoramaExtension',
              ],
            }),
      }

      // Initialize the viewer
      const newViewer = new Autodesk.Viewing.Viewer3D(htmlDiv, options)
      if (newViewer.start() > 0) {
        // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
        console.error('Failed to create a Viewer: WebGL not supported.')
        return
      }

      setViewer(newViewer)

      // Listen for the extension loaded event
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper event type
      newViewer.addEventListener(
        Autodesk.Viewing.EXTENSION_LOADED_EVENT,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper event type
        (event: any) => {
          if (event.extensionId === 'PanoramaExtension') {
            const panoramaExtension =
              newViewer.getExtension('PanoramaExtension')
            if (panoramaExtension) {
              // eslint-disable-next-line no-console -- TODO: Replace with proper debug logging
              console.debug(
                'Found PanoramaTool',
                panoramaExtension.panoramaTool,
              )
              panoramaTool.current = panoramaExtension.panoramaTool
            } else {
              // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
              console.warn(
                'PanoramaExtension not found or not loaded correctly.',
              )
            }
          }
        },
      )

      // Clean up the viewer on unmount
      return () => {
        newViewer.finish()
      }
    }
  }, [autodeskModule, projectId])

  return {
    viewer,
    getViewerPosition,
    setViewerPosition,
  }
}
